import { motion } from 'framer-motion'
import RcDrawer from 'rc-drawer'
import styled, { createGlobalStyle } from 'styled-components'
import { LoadingOverlay } from '../LoadingOverlay/LoadingOverlay'

export const GlobalStyle = createGlobalStyle`
  :root{
    --drawer-width: 100%;
    --drawer-width: 39rem;
  }

  @media screen and (max-width: 389px) {
    :root{
      --drawer-width: 100%;
    }
  }

  .rc-drawer-content-wrapper {
    width: var(--drawer-width);
  }
`

export const Shadow = styled(motion.div)`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 1049;
  background: rgba(0, 0, 0, 0.7);
  /* we set "pointer-events: auto" to overwrite a "pointer-events: none" triggered by a modal invocation */
  pointer-events: auto;
`

export const StyledRcDrawer = styled(RcDrawer)<{ placement: string }>`
  display: flex;
  flex-direction: column;
`

export const CloseColumn = styled.div<{ placement: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: calc(100% - var(--drawer-width));
  position: absolute;
  top: 0;
  left: ${({ placement }) => (placement === 'right' ? 0 : 'auto')};
  right: ${({ placement }) => (placement === 'left' ? 0 : 'auto')};
  bottom: 0;
`

export const Content = styled(LoadingOverlay)`
  height: 100%;
  overflow-y: scroll;
`
